import React from 'react'

export default function AvatarCharecter({ name, className = 'w-6 h-6' }) {
    const initials = name
        .split(' ')
        .map((word, i) => i < 2 ? word[0].toUpperCase() : '')
        .join('');
    return (
        <div className="flex items-center space-x-2">
            <div className="relative group inline-block">
                <div className={`rounded-full bg-blue-500 flex items-center justify-center text-white font-bold ${className} `}>
                    {initials}
                </div>
                <div
                    className="absolute left-1/2 -translate-x-1/4 bottom-full mb-2 px-2 py-1 text-sm text-white bg-gray-500 rounded
                                            opacity-0 group-hover:opacity-100 transition-opacity duration-200
                                            whitespace-nowrap"
                >
                    {name}
                </div>
            </div>

            {/* <span>{name}</span> */}
        </div>
    )
}
